import { SourceSettings } from '../config';

// the threshold inputs are constrained to integers, but truncate defensively -
// a non-integer reaching BigInt() throws a RangeError
export const thresholdsFromSettings = (source: SourceSettings) => ({
  Medium: BigInt(Math.trunc(source.medium)),
  High: BigInt(Math.trunc(source.high)),
});
